<script>
  export default {
    methods: {
      $_filterObjectParameterBuilder_mergeFilterInstanceWithDimensionFilter (parameters, dimFilter) {
        // receives single value filter obj: {filter_type: 'product_filters', 'field': 'hlev_id', 'id': 2345753}
        if (typeof dimFilter === 'undefined') {
          throw new Error('El objeto dim filter es undefined')
        }
        let testArray = parameters.parameters[dimFilter['metadata']['filterType']][dimFilter['metadata']['field']].includes(dimFilter['metadata']['id'])
        if (testArray) {
          return parameters
        } else {
          parameters.parameters[dimFilter['metadata']['filterType']][dimFilter['metadata']['field']].push(dimFilter['metadata']['id'])
          return parameters
        }
      },
      $_filterObjectParameterBuilder_filterByFilterInstance (obj, filterObjectInstance) {
        // receives list of values for filter obj: {filter_type: 'product_filters', 'field': 'hlev_id', 'id': [2345753]}
        // if item already exists, it is not been included
        let testArray = filterObjectInstance[obj['filter_type']][obj['field']].includes(obj['id'])
        if (testArray) {
          return filterObjectInstance
        } else {
          filterObjectInstance[obj['filter_type']][obj['field']].push(obj['id'])
          return filterObjectInstance
        }
      },
      $_filterObjectParameterBuilder_removeFilterItem (obj, filterObjectInstance) {
        this.$lodash.remove(filterObjectInstance[obj['filter_type']][obj['field']], function (e) {
          return e === obj['id']
        })
        return filterObjectInstance
      },
      // $_filterObjectParameterBuilder_clearChildObject (selection, filterObjectInstance) {
      //   // let filterType = 'store_filters'
      //   // let removeFrom = filterObjectInstance[filterType][level]
      //   // filterObjectInstance[filterType][level] = this.$lodash.difference(removeFrom, itemsToRemove)
      //   return filterObjectInstance
      // },
      $_filterObjectParameterBuilder_clearSelectorsGivenRemovedOption (removedObj, filterOptionsObject, filterOptionsObjectRendered) {
        // First get all options from parent to child and build and object with it: optionsToRemove
        let classId = removedObj['class_id']
        let data = filterOptionsObject
        let removedOption = removedObj['id']
        let removedLevel = removedObj['field']
        // let filterType = removedObj['filter_type']
        let levelsInClass = data.find(x => x.id === classId).levelList.map(x => x.id)
        let optionsToRemove = {
        }

        // delete where first level has no parents.
        let a = levelsInClass.indexOf(removedLevel)
        let levelsToRemove = null
        if (a !== 0) {
          levelsToRemove = levelsInClass.slice(a)
        } else {
          levelsToRemove = levelsInClass
        }
        if (levelsToRemove.length > 1) {
          // set initial object
          optionsToRemove[removedLevel] = [removedOption]
          levelsToRemove.forEach((i, index) => {
            // Get options just for child levels, from selected level wich is the 'removedLevel'
            if (i !== removedLevel) {
              optionsToRemove[i] = data[0]['levelList'].find(x => x.id === i)['options'].filter(x => x.parent_id === removedOption).map(x => x.id)
              let parentLevel = levelsToRemove[index - 1]
              let parentOptions = optionsToRemove[parentLevel]
              parentOptions.forEach((p) => {
                optionsToRemove[i].push(data[0]['levelList'].find(x => x.id === i)['options'].filter(x => x.parent_id === p).map(x => x.id)[0])
              })
            }
          })
          // Second, for every level, remove from 'selectedValue' the options collected in 'optionsToRemove'
          let levelList = filterOptionsObjectRendered.find(x => x.id === classId)['levelList']
          levelsToRemove.forEach((i) => {
            let level = levelList.filter(x => x.id === i)
            let itemsToRemove = optionsToRemove[i]
            let t = level[0]['selectedValue']
            let o = level[0]['options']
            itemsToRemove.forEach((r) => {
              let indexToRemove = t.findIndex(v => v.id === r)
              if (indexToRemove > -1) {
                levelList.find(x => x.id === i)['selectedValue'].splice(indexToRemove, 1)
              }
              if (r !== removedOption) {
                let indexToRemoveOpt = o.findIndex(v => v.id === r)
                if (indexToRemoveOpt > -1) {
                  levelList.find(x => x.id === i)['options'].splice(indexToRemoveOpt, 1)
                }
              }
            })
          })
          return filterOptionsObjectRendered
        } else {
          return filterOptionsObjectRendered
        }
      },
      $_filterObjectParameterBuilder_setInitRenderObject (initRenderObject) {
        //  select classes which contains more than one level and clean the child's so user dont see options in the child selects
        let classList = initRenderObject.filter(x => x.levelList.length > 1)
        // iter in class list, and splice key levelList to leave just one item
        classList.forEach((i) => {
          let idLevelList = i['levelList'].map(x => x.id)
          idLevelList.shift()
          idLevelList.forEach((t) => {
            i['levelList'].find(x => x.id === t)['options'] = []
          })
        })
        return initRenderObject
      },
      $_filterObjectParameterBuilder_checkIfObjectContainsSelections (filterOptionsObjectRendered) {
        let count = 0
        let a = filterOptionsObjectRendered
        a.forEach((i) => {
          i['levelList'].forEach((t) => {
            let c = 0
            c = t['selectedValue'].length
            if (c > 0) {
              count = count + 1
            }
          })
        })
        if (count > 0) {
          return true
        } else {
          return false
        }
      },
      $_filterObjectParameterBuilder_buildFilterObject (renderObject, filterType, vuexFilterObjectActiveInstance) {
        // Build object filter base on selected option from select component,
        // where then this object is commited into vuex and available for request parameters
        let filterObject = vuexFilterObjectActiveInstance
        renderObject.forEach((i) => {
          let levelList = i['levelList']
          levelList.forEach((t) => {
            let selectedIdList = t['selectedValue'].map(x => x.id)
            filterObject[filterType][t['id']] = selectedIdList
          })
        })
        return filterObject
      },
      $_filterObjectParameterBuilder_setChildOptions (selection, renderObject, originalCategoryObject) {
        // Set child options when selectors are in Hierarchy
        let childLevelId = selection['child_level_id']
        let levelId = selection['field']
        let selectedId = selection['id']
        let classId = selection['class_id']
        if (childLevelId !== 'None') {
          let childLevelOpt = originalCategoryObject.find(x => x.id === classId)['levelList'].find(x => x.id === childLevelId)['options']
          let childSelectedOpt = childLevelOpt.filter(x => x['parent_id'] === selectedId)
          let childOptArray = renderObject.find(x => x.id === classId)['levelList'].find(x => x.id === childLevelId)['options']
          childOptArray = [...childOptArray, ...childSelectedOpt]
          renderObject.find(x => x.id === classId)['levelList'].find(x => x.id === childLevelId)['options'] = childOptArray
        }
        renderObject.find(x => x.id === classId)['levelList'].find(x => x.id === levelId)['selectedValue'].push(selection)
        return renderObject
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/mixins/FilterObjectParameterBuilder.vue